var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWrongIcon = function SvgWrongIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.283,
    height: 21.282,
    viewBox: "0 0 21.283 21.282",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrong-icon",
    transform: "translate(-1057.987 -2714.833)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 10.641,
    cy: 10.641,
    r: 10.641,
    transform: "translate(1057.987 2714.833)",
    fill: "#121112"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27507",
    "data-name": "Path 27507",
    d: "M1073.624,2720.52a.84.84,0,0,0-1.186,0l-3.809,3.809-3.809-3.809a.839.839,0,0,0-1.186,1.186l3.809,3.809-3.809,3.809a.839.839,0,1,0,1.186,1.186l3.809-3.809,3.809,3.809a.839.839,0,0,0,1.186-1.186l-3.81-3.809,3.81-3.809a.84.84,0,0,0,0-1.186",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWrongIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wrong-icon.88bf50c30199a54c06cc26bf11d035af.svg";